var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalIngresos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2.4 TotalIngresos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1-Dashboard",
    transform: "translate(-1148.000000, -248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-4",
    transform: "translate(1128.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.4-TotalIngresos",
    transform: "translate(20.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.3,
    fill: "#EED462",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(11.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.263,10.132 C20.263,15.728 15.727,20.264 10.131,20.264 C4.536,20.264 0,15.728 0,10.132 C0,4.536 4.536,0 10.131,0 C15.727,0 20.263,4.536 20.263,10.132 Z",
    id: "Stroke-1",
    stroke: "#EED462",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.706,9.1122 C9.61,8.6582 9.528,8.4592 9.528,8.2072 C9.528,7.8742 9.816,7.6752 10.299,7.6752 C10.965,7.6752 11.383,7.9152 11.561,8.0172 C11.688,8.0892 11.84,8.1032 11.978,8.0542 C12.116,8.0052 12.226,7.8972 12.277,7.7602 L12.578,6.9692 C12.664,6.7412 12.574,6.4842 12.363,6.3612 C11.968,6.1292 11.536,5.9812 11.051,5.9132 L11.051,5.2092 C11.051,4.9322 10.827,4.7092 10.551,4.7092 L9.808,4.7092 C9.531,4.7092 9.308,4.9322 9.308,5.2092 L9.308,6.0222 C8.194,6.3552 7.497,7.2342 7.497,8.3512 C7.497,9.7962 8.657,10.4462 9.787,10.8892 C10.75,11.2792 10.831,11.5912 10.831,11.8532 C10.831,12.2632 10.467,12.5282 9.903,12.5282 C9.4,12.5282 8.859,12.3672 8.454,12.0962 C8.326,12.0112 8.164,11.9892 8.019,12.0382 C7.873,12.0862 7.757,12.1992 7.706,12.3442 L7.418,13.1482 C7.343,13.3582 7.416,13.5932 7.598,13.7232 C8.007,14.0152 8.602,14.2262 9.224,14.3072 L9.224,15.0552 C9.224,15.3312 9.447,15.5552 9.724,15.5552 L10.479,15.5552 C10.755,15.5552 10.979,15.3312 10.979,15.0552 L10.979,14.2042 C12.128,13.8572 12.874,12.9202 12.874,11.7692 C12.874,10.1972 11.714,9.5232 10.706,9.1122",
    id: "Fill-3",
    fill: "#EED462"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalIngresos);
export default __webpack_public_path__ + "static/media/TotalIngresos.c0c5d0a75fcbd32e4052a9915de26111.svg";
export { ForwardRef as ReactComponent };